import { ChangeEvent, useState } from "react"
import { useI18n } from "providers/I18n"

import { queryCache, useMutation } from "react-query"
import { createBaseRate, CreateBaseRatePayload } from "api/ratecard"

import * as DG from "ui/dialogs"
import Button from "ui/buttons/Button"
import { TextInput } from "components/inputs/TextInput"

import { DEFAULT_ID } from "./utils"

type CreateLocationModalProps = {
  open: boolean
  onClose: () => void
  //
  rateCardId: string
  channelId: string
  used: string[]
}

export function CreateLocationModal(props: CreateLocationModalProps) {
  const { open, onClose, rateCardId, channelId, used } = props
  const { t } = useI18n()
  const [location, setLocation] = useState<string>(() => "")

  const [mu, result] = useMutation(createBaseRate)

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const v = evt.target.value
    setLocation(v)
  }
  const isLocationUsed = used.includes(location)

  const handleSubmit = () => {
    if (isLocationUsed) {
      // set an error and
      return
    }
    const pld: CreateBaseRatePayload = { rateCardId, location }
    if (channelId !== DEFAULT_ID) {
      pld.supplierProductId = channelId
    }
    mu(pld)
      .then(() => {
        queryCache.invalidateQueries(["rate-card-details", rateCardId])
      })
      .then(() => {
        onClose()
      })
  }

  const id = "create-location-modal"

  return (
    <DG.Dialog open={open} onClose={onClose} id={id}>
      <DG.DialogHeader>
        <DG.DialogTitle id={id}>
          {t("rate.card.location.add.title")}
        </DG.DialogTitle>
        <DG.DialogClose onClose={onClose} />
      </DG.DialogHeader>

      <DG.DialogContent center paddingTop>
        <div>
          <TextInput
            value={location}
            onChange={handleChange}
            name="location"
            label="Location"
            fullWidth
          />
        </div>
        {isLocationUsed && (
          <span className="BodyBody-2RedRegular">
            {t("rate.card.location.title.used")}
          </span>
        )}
      </DG.DialogContent>
      <DG.DialogFooter>
        <DG.DialogActions>
          <Button variant="outlined" color="primary" onClick={onClose}>
            {t("actions.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!location || result.isLoading || isLocationUsed}
            onClick={handleSubmit}
          >
            {t("actions.submit")}
          </Button>
        </DG.DialogActions>
      </DG.DialogFooter>
    </DG.Dialog>
  )
}
